export const hero = {
    headline:    "Target your weak spots.\nPass with confidence.",
    subheadline: "Topic-focused CPC-style practice quizzes with detailed explanations. Buy once — yours forever, no expiry, no subscription.",
    primaryCTA:  { label: "See the Quizzes",  href: "#cpc" },
    secondaryCTA:{ label: "Try Free Sample",  href: "/sample/free-terminology" },
    disclaimer:  "Free samples available — no signup required.",
}

export const howItWorks = {
    heading:     "How it works",
    subheading:  "Three steps. No fluff.",
    steps: [
        {
            number:      "01",
            title:       "Pick your topic",
            description: "Choose the area you want to strengthen — Terminology, ICD-10, E&M, Surgery, HCPCS, or Compliance. Or grab the full bundle.",
        },
        {
            number:      "02",
            title:       "Work through 35 questions",
            description: "Every question mirrors the CPC style. Timed, multiple choice, one at a time — just like the real thing.",
        },
        {
            number:      "03",
            title:       "Review your score and gaps",
            description: "See exactly what you got right and wrong, with a clear explanation for every question. Know where to focus next.",
        },
        {
            number:      "04",
            title:       "Access on any device, forever",
            description: "After purchase, your access code arrives by email instantly. Enter it here on any device — no account needed, no expiry, no subscription.",
        },
    ],
}

export const whySection = {
    heading:    "Why Qwiztime",
    subheading: "Most CPC and CRC prep resources throw everything at you at once. Qwiztime was built around a different idea — that targeted practice by topic is more effective than randomized question banks. Every quiz focuses on one area so you can find exactly where you're weak and fix it before exam day.",
    features: [
        {
            title:       "Topic-specific, not random",
            description: "Each quiz targets one area — so you know if ICD-10 is your gap, not just that you scored 70% on a mixed test.",
        },
        {
            title:       "Explanations that teach",
            description: "Every answer includes a rationale tied to coding guidelines. You learn the rule, not just the right letter.",
        },
        {
            title:       "Buy once, yours forever",
            description: "No 30-day countdown. No subscription. Pay once and come back any time — on any device.",
        },
        {
            title:       "7-day money-back guarantee",
            description: "If the quiz isn't what you expected, email us within 7 days and we'll refund you — no questions asked.",
        },
    ],
}

export const sampleCTA = {
    heading:     "Not sure yet? Try it free.",
    description: "Three free CPC-style quizzes — no signup, no credit card. Get a feel for the format before you buy.",
    cta:         { label: "Start Free Sample", href: "/sample/free-terminology" },
}
